import { render, staticRenderFns } from "./LocaleIcon.vue?vue&type=template&id=3bc19cc2&"
import script from "./LocaleIcon.vue?vue&type=script&lang=js&"
export * from "./LocaleIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports